import { render } from "./HeroiconsSolidArrowDown.vue?vue&type=template&id=1472426e"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowDown.vue"]])

export default __exports__